
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/currently-reading",
      function () {
        return require("private-next-pages/currently-reading.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/currently-reading"])
      });
    }
  